// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.source-list {
    margin-top: 10px;
    padding-top: 8px;

    border-top: 1px solid rgba(0, 0, 0, 0.08);

    display: flex;
    flex-direction: column;
    gap: 8px;
}

.source-list-title {
    font-size: 11px;
    font-weight: 600;

    color: #6b7280;

    text-transform: uppercase;
    letter-spacing: 0.05em;

    margin: 0 0 4px 0;
}

.source-card {
    background: white;

    border: 1px solid #e5e7eb;
    border-radius: 8px;

    padding: 8px 10px;

    display: flex;
    flex-direction: column;
    gap: 4px;

    font-size: 12px;
    color: #374151;

    text-align: start;
    unicode-bidi: plaintext;
}

.source-title {
    font-size: 12px;
    font-weight: 600;

    color: #1f2937;

    text-align: start;
    unicode-bidi: plaintext;

    line-height: 1.4;
}

.source-meta {
    font-size: 11px;
    color: #6b7280;

    text-align: start;
    unicode-bidi: plaintext;

    line-height: 1.4;
}

.source-label {
    font-weight: 600;
    color: #4b5563;
}

.source-excerpt {
    margin: 4px 0 0 0;

    padding-inline-start: 8px;

    border-inline-start: 2px solid #3B82F6;

    font-size: 11px;
    color: #6b7280;

    line-height: 1.6;

    text-align: start;
    unicode-bidi: plaintext;

    white-space: pre-wrap;
    word-break: break-word;
}

.source-link {
    display: inline-block;

    margin-top: 4px;

    font-size: 11px;
    font-weight: 500;

    color: #3B82F6;

    text-decoration: none;

    align-self: flex-start;
}

.source-link:hover {
    text-decoration: underline;
}

.source-card[dir="rtl"] {
    text-align: right;
}

.source-card[dir="rtl"] .source-link {
    align-self: flex-end;
}

.source-card[dir="rtl"] .source-excerpt {
    border-inline-start: none;
    border-inline-end: 2px solid #3B82F6;

    padding-inline-start: 0;
    padding-inline-end: 8px;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SourceList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;;IAEhB,yCAAyC;;IAEzC,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,yBAAyB;IACzB,sBAAsB;;IAEtB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;;IAEjB,yBAAyB;IACzB,kBAAkB;;IAElB,iBAAiB;;IAEjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;;IAER,eAAe;IACf,cAAc;;IAEd,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,iBAAiB;IACjB,uBAAuB;;IAEvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;;IAEd,iBAAiB;IACjB,uBAAuB;;IAEvB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iBAAiB;;IAEjB,yBAAyB;;IAEzB,sCAAsC;;IAEtC,eAAe;IACf,cAAc;;IAEd,gBAAgB;;IAEhB,iBAAiB;IACjB,uBAAuB;;IAEvB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;;IAErB,eAAe;;IAEf,eAAe;IACf,gBAAgB;;IAEhB,cAAc;;IAEd,qBAAqB;;IAErB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;;IAEpC,uBAAuB;IACvB,uBAAuB;AAC3B","sourcesContent":[".source-list {\n    margin-top: 10px;\n    padding-top: 8px;\n\n    border-top: 1px solid rgba(0, 0, 0, 0.08);\n\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.source-list-title {\n    font-size: 11px;\n    font-weight: 600;\n\n    color: #6b7280;\n\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n\n    margin: 0 0 4px 0;\n}\n\n.source-card {\n    background: white;\n\n    border: 1px solid #e5e7eb;\n    border-radius: 8px;\n\n    padding: 8px 10px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n\n    font-size: 12px;\n    color: #374151;\n\n    text-align: start;\n    unicode-bidi: plaintext;\n}\n\n.source-title {\n    font-size: 12px;\n    font-weight: 600;\n\n    color: #1f2937;\n\n    text-align: start;\n    unicode-bidi: plaintext;\n\n    line-height: 1.4;\n}\n\n.source-meta {\n    font-size: 11px;\n    color: #6b7280;\n\n    text-align: start;\n    unicode-bidi: plaintext;\n\n    line-height: 1.4;\n}\n\n.source-label {\n    font-weight: 600;\n    color: #4b5563;\n}\n\n.source-excerpt {\n    margin: 4px 0 0 0;\n\n    padding-inline-start: 8px;\n\n    border-inline-start: 2px solid #3B82F6;\n\n    font-size: 11px;\n    color: #6b7280;\n\n    line-height: 1.6;\n\n    text-align: start;\n    unicode-bidi: plaintext;\n\n    white-space: pre-wrap;\n    word-break: break-word;\n}\n\n.source-link {\n    display: inline-block;\n\n    margin-top: 4px;\n\n    font-size: 11px;\n    font-weight: 500;\n\n    color: #3B82F6;\n\n    text-decoration: none;\n\n    align-self: flex-start;\n}\n\n.source-link:hover {\n    text-decoration: underline;\n}\n\n.source-card[dir=\"rtl\"] {\n    text-align: right;\n}\n\n.source-card[dir=\"rtl\"] .source-link {\n    align-self: flex-end;\n}\n\n.source-card[dir=\"rtl\"] .source-excerpt {\n    border-inline-start: none;\n    border-inline-end: 2px solid #3B82F6;\n\n    padding-inline-start: 0;\n    padding-inline-end: 8px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
